import React, { FC, useState, type PropsWithChildren } from "react";
import AccordionSection from "./AccordionSection";
import { Switch } from "../../../../../components";
import type { ProfileLinkConfig } from "../../../../../client";

const SettingRow: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex items-center justify-between gap-2">{children}</div>
  );
};

const SettingText: FC<PropsWithChildren> = ({ children }) => {
  return <p className="text-gray-9 text-sm font-medium grow">{children}</p>;
};

interface WorkExperienceLinkSettingsProps {
  disabled?: boolean;
  linkConfig?: ProfileLinkConfig;
  onUpdate: (payload: Partial<ProfileLinkConfig>) => void;
}

const WorkExperienceLinkSettings: FC<WorkExperienceLinkSettingsProps> = ({
  disabled,
  linkConfig,
  onUpdate,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <AccordionSection
      title="Work experience"
      subtitle={(() => {
        const activeSettings: string[] = [];
        if (linkConfig?.workplaceLinkConfig?.displaySkills) {
          activeSettings.push("Skills");
        } else {
          activeSettings.push("No skills");
        }
        if (linkConfig?.workplaceLinkConfig?.displayDescription) {
          activeSettings.push("show descriptions");
        } else {
          activeSettings.push("no descriptions");
        }
        if (activeSettings.length === 0) {
          return "No settings active";
        }
        return activeSettings.join(", ");
      })()}
      expanded={isExpanded}
      onToggle={() => setIsExpanded(!isExpanded)}
    >
      <SettingRow>
        <Switch
          checked={linkConfig?.workplaceLinkConfig?.displaySkills}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              workplaceLinkConfig: {
                ...linkConfig?.workplaceLinkConfig,
                displaySkills: checked,
              },
            });
          }}
        />
        <SettingText>Skills</SettingText>
      </SettingRow>
      <SettingRow>
        <Switch
          checked={linkConfig?.workplaceLinkConfig?.displayDescription}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              workplaceLinkConfig: {
                ...linkConfig?.workplaceLinkConfig,
                displayDescription: checked,
              },
            });
          }}
        />
        <SettingText>Descriptions</SettingText>
      </SettingRow>
      <SettingRow>
        <Switch
          checked={linkConfig?.workplaceLinkConfig?.displaySkillIcons ?? true}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              workplaceLinkConfig: {
                ...linkConfig?.workplaceLinkConfig,
                displaySkillIcons: checked,
              },
            });
          }}
        />
        <SettingText>Icons</SettingText>
      </SettingRow>
    </AccordionSection>
  );
};

export default WorkExperienceLinkSettings;
